import { Stack } from "expo-router";

/**
 * The Table display's layout: a headerless stack for the code entry (`/t`) and the board
 * (`/t/<code>`). A sibling of `(app)` like `browse`, so no sign-in mounts around a monitor.
 */
export default function TableDisplayLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
